import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, EMPTY } from 'rxjs';
import { AuthService } from '../services/Auth/auth-service';
import { ToastrService } from 'ngx-toastr';
import { getHttpErrorMessage } from '../utils/http-error-message.util';

function withApiErrorMessage(error: HttpErrorResponse) {
  const message = getHttpErrorMessage(error, error.message || 'An error occurred');
  if (message === error.message) {
    return error;
  }
  return {
    name: error.name,
    status: error.status,
    statusText: error.statusText,
    url: error.url,
    ok: false,
    headers: error.headers,
    error: error.error,
    message,
  };
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

       // Check if this is an authentication-related endpoint that should not trigger automatic logout
       const isAuthEndpoint = req.url.includes('/login') || 
       req.url.includes('/auth/get-otp') || 
       req.url.includes('/auth/login-with-otp') ||
       req.url.includes('/auth/verify-otp') || 
       req.url.includes('/auth/update-password') ||
       req.url.includes('/auth/agency-login') ||
       req.url.includes('/auth/login-as') ||
       req.url.includes('/forgot-password') || 
       req.url.includes('/send-otp') || 
       req.url.includes('/verify-otp') || 
       req.url.includes('/reset-password');
       const isHelpdeskApi = req.url.includes('helpdeskapi.workluge.com');
    // Centralized error handling logic
      if (error.status === 401) {
        // Auto logout if 401 response returned from api
        // Only auto logout for 401 if it's not an authentication endpoint
        if (!isAuthEndpoint && !isHelpdeskApi) {
          // Show token expired toast notification
          toastr.error('Your session has expired. Please log in again.', '', {
            timeOut: 6000,
          });
          
          // Delay logout slightly to allow user to see the toast
          setTimeout(() => {
            authService.forceLogout('Session expired (401 Unauthorized)');
          }, 500);
          
          // Return EMPTY to completely suppress the error
          return EMPTY;
        }
      }

      return throwError(() => withApiErrorMessage(error));
    })
  );
};
